export const DoctorRating = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  width: '100%',
  isCompact: (el, s) => s.compact === true,

  '.isCompact': {
    padding: '0',
    background: 'transparent',
    border: 'none',
    gap: 'Y'
  },

  TopRow: {
    flow: 'x',
    gap: 'Z',
    align: 'center flex-start',

    StarDisplay: {
      flow: 'x',
      gap: 'W',
      children: (el, s) => {
        const rating = s.rating || 0
        return Array.from({ length: 5 }, (_, i) => ({
          filled: i < Math.round(rating),
          index: i
        }))
      },
      childrenAs: 'state',
      childProps: {
        extends: 'Icon',
        icon: 'star',
        width: 'A',
        height: 'A',
        color: (el, s) => s.filled ? 'teal' : 'inkBorder'
      }
    },

    AvgRating: {
      text: (el, s) => String(s.rating || '0.0'),
      fontSize: 'B',
      fontWeight: '700',
      color: 'inkText'
    },

    TotalReviews: {
      text: (el, s) => '(' + (s.totalReviews || 0) + ' {{ reviews | polyglot }})',
      fontSize: 'Z',
      color: 'inkMuted',
      alignSelf: 'center'
    }
  },

  '.isCompact > TopRow': {
    AvgRating: { fontSize: 'Z' },
    StarDisplay: {
      childProps: { width: 'Z', height: 'Z' }
    }
  },

  Categories: {
    flow: 'y',
    gap: 'Y',
    marginTop: 'Y',
    show: (el, s) => !s.compact,

    ProfRow: {
      flow: 'x',
      gap: 'Z',
      align: 'center flex-start',
      CatLabel: { text: '{{ professionalism | polyglot }}', fontSize: 'Y', color: 'inkMuted', width: 'F', flexShrink: '0' },
      CatStars: {
        flow: 'x',
        gap: 'W',
        children: (el, s) => {
          const val = (s.categories && s.categories.professionalism) || 0
          return Array.from({ length: 5 }, (_, i) => ({ filled: i < Math.round(val) }))
        },
        childrenAs: 'state',
        childProps: { extends: 'Icon', icon: 'star', width: 'Y', height: 'Y', color: (el, s) => s.filled ? 'teal' : 'inkBorder' }
      },
      CatVal: { text: (el, s) => String((s.categories && s.categories.professionalism) || '0'), fontSize: 'Y', fontWeight: '600', color: 'inkText' }
    },

    PainRow: {
      flow: 'x',
      gap: 'Z',
      align: 'center flex-start',
      CatLabel: { text: '{{ painManagement | polyglot }}', fontSize: 'Y', color: 'inkMuted', width: 'F', flexShrink: '0' },
      CatStars: {
        flow: 'x',
        gap: 'W',
        children: (el, s) => {
          const val = (s.categories && s.categories.painManagement) || 0
          return Array.from({ length: 5 }, (_, i) => ({ filled: i < Math.round(val) }))
        },
        childrenAs: 'state',
        childProps: { extends: 'Icon', icon: 'star', width: 'Y', height: 'Y', color: (el, s) => s.filled ? 'teal' : 'inkBorder' }
      },
      CatVal: { text: (el, s) => String((s.categories && s.categories.painManagement) || '0'), fontSize: 'Y', fontWeight: '600', color: 'inkText' }
    },

    ExplRow: {
      flow: 'x',
      gap: 'Z',
      align: 'center flex-start',
      CatLabel: { text: '{{ explanationQuality | polyglot }}', fontSize: 'Y', color: 'inkMuted', width: 'F', flexShrink: '0' },
      CatStars: {
        flow: 'x',
        gap: 'W',
        children: (el, s) => {
          const val = (s.categories && s.categories.explanationQuality) || 0
          return Array.from({ length: 5 }, (_, i) => ({ filled: i < Math.round(val) }))
        },
        childrenAs: 'state',
        childProps: { extends: 'Icon', icon: 'star', width: 'Y', height: 'Y', color: (el, s) => s.filled ? 'teal' : 'inkBorder' }
      },
      CatVal: { text: (el, s) => String((s.categories && s.categories.explanationQuality) || '0'), fontSize: 'Y', fontWeight: '600', color: 'inkText' }
    },

    PunctRow: {
      flow: 'x',
      gap: 'Z',
      align: 'center flex-start',
      CatLabel: { text: '{{ punctuality | polyglot }}', fontSize: 'Y', color: 'inkMuted', width: 'F', flexShrink: '0' },
      CatStars: {
        flow: 'x',
        gap: 'W',
        children: (el, s) => {
          const val = (s.categories && s.categories.punctuality) || 0
          return Array.from({ length: 5 }, (_, i) => ({ filled: i < Math.round(val) }))
        },
        childrenAs: 'state',
        childProps: { extends: 'Icon', icon: 'star', width: 'Y', height: 'Y', color: (el, s) => s.filled ? 'teal' : 'inkBorder' }
      },
      CatVal: { text: (el, s) => String((s.categories && s.categories.punctuality) || '0'), fontSize: 'Y', fontWeight: '600', color: 'inkText' }
    }
  }
}
